// @flow

/**
 * And extremely simple "polyfill" for 100% modern browsers: Firefox 68+, Chrome 71+
 */

import './console';

// Set process.env.NODE_ENV to help Apollo notice it's in production mode,
// so it doesn't do expensive operations (e.g. unnecessary deep freeze)
if (typeof process === 'undefined') {
  // eslint-disable-next-line no-restricted-globals
  window.process = { env: { NODE_ENV: DEBUG ? 'development' : 'production' } };
}

// eslint-disable-next-line no-underscore-dangle,no-restricted-globals
window.__POLYFILLS_COMPLETE__ = true;
if (typeof __POLYFILLS_CALLBACK__ === 'function') {
  __POLYFILLS_CALLBACK__();
}
